var prop = {

}

// 对战道具
prop.battleItem = [
    {
        "name":"Controller",
        "label":"得分区控制器",
        "descripton":"在友方得分区内或附近使用，可在短时间内加强该得分区的体力回复效果和护盾效果。\n在对方得分区内或附近使用，可在短时间内使该得分区的体力回复效果和护盾效果无效。",
        "effectDescrption":"需要以1个得分区作为目标才能使用。对友方得分区使用时，在4秒内使其提供的护盾效果翻倍，体力回复效果加速到0.5秒/次，且友方宝可梦已获得的得分区护盾效果会被替换成强化护盾并在道具持续时间结束后恢复为正常效果的护盾。对对方得分区使用时，在4秒内使其提供的护盾效果和体力回复效果无效。\n对友方得分区使用可以覆盖对方队伍宝可梦对同一得分区使用的得分区控制器的效果。同队的宝可梦对同一个得分区使用多个得分区控制器只会刷新其持续时间。友方得分区获得的强化效果可以与其他来自得分区控制器以外的强化效果叠加（比如密勒顿的强子引擎对得分区的效果）。",
        "time":"90秒"
    },
    {
        "name":"EjectButton",
        "label":"逃脱按键",
        "descripton":"立即向指定方向进行移动。",
        "effectDescrption":"立即向指定方向进行移动。",
        "time":"80秒"
    },
    {
        "name":"Ganrao",
        "label":"得分加速装置",
        "descripton":"在短时间内得分速度翻倍。",
        "effectDescrption":"在10秒内得分速度翻倍。",
        "time":"60秒"
    },
    {
        "name":"Gear",
        "label":"迟缓烟雾",
        "descripton":"放出烟雾，使对方宝可梦在短时间内大幅降低移动速度和普通攻击的速度。",
        "effectDescrption":"在自身周围放出烟雾，在2秒内使烟雾中的对方宝可梦移动速度降低80%，普通攻击的速度降低50%。",
        "time":"35秒"
    },
    {
        "name":"Potion",
        "label":"伤药",
        "descripton":"回复自身少量体力。",
        "effectDescrption":"回复自身 (20%最大体力 + 160) 的体力。",
        "time":"30秒"
    },
    {
        "name":"Purify",
        "label":"万灵药",
        "descripton":"可治愈自己的宝可梦的异常状态，并在短时间内进入妨碍无效状态。",
        "effectDescrption":"可治愈自己的宝可梦的异常状态，并在1.5秒内进入妨碍无效状态。",
        "time":"55秒"
    },
    {
        "name":"ShedinjaDoll",
        "label":"脱壳忍者玩偶",
        "descripton":"在短时间内无法动弹，但相对地不会受到伤害，也不会陷入异常状态。",
        "effectDescrption":"在2秒内无法动弹，但相对地不会受到伤害，也不会陷入异常状态。",
        "time":"45秒"
    },
    {
        "name":"Tail",
        "label":"向尾喵的尾巴",
        "descripton":"让野生宝可梦在短时间内无法动弹，并提高自身对其造成的伤害。",
        "effectDescrption":"在3秒内对1只野生宝可梦施加减益效果，使其无法攻击且自身对其造成伤害时会造成 (100% 攻击 + 60% 特攻 + 10 × (等级-1) + 100) 的追加伤害。造成追加伤害的效果有0.5秒的等待时间。（对大型野生宝可梦使用时不会使其无法攻击）",
        "time":"22秒"
    },
    {
        "name":"XAttack",
        "label":"力量强化",
        "descripton":"在短时间内提高自己的宝可梦的攻击、特攻以及普通攻击的速度。",
        "effectDescrption":"在6.5秒内自身的攻击和特攻提高20%，普通攻击的速度提高25%。",
        "time":"40秒"
    },
    {
        "name":"XSpeed",
        "label":"速度强化",
        "descripton":"在短时间内提高自身移动速度且移动速度不会被降低。",
        "effectDescrption":"在6秒内自身的移动速度提高45%且不会受到降低移动速度的效果影响。",
        "time":"50秒"
    }
]

// 持有物
prop.heldItem = [
    {
        "name":"AssaultVest",
        "label":"突击背心",
        "effectAdd":"每次升级，偶数等级特防+3.4，奇数等级体力+18",
        "effectDescrption":"脱离战斗期间，获得可让9%/12%/15%最大体力的特攻伤害无效的护盾。此护盾在完全失效前不会刷新。（进入脱离战斗状态需要脱离战斗5秒以上）",
        "descripton":"脱离战斗期间，获得可让9%/12%/15%最大体力的特攻伤害无效的护盾。",
        "sort":"防御"
    },
    {
        "name":"ChoiceSpecs",
        "label":"讲究眼镜",
        "effectAdd":"特攻+9，每次升级，特攻+1",
        "effectDescrption":"招式命中时追加一次 (40/50/60 + 30%/35%/40%特攻) 的伤害，此追加伤害只会对1只对方宝可梦生效。（等待时间：8秒）",
        "descripton":"招式命中时追加一次40/50/60以上的伤害，且特攻越高追加的伤害越高。",
        "sort":"攻击"
    },
    {
        "name":"ComboScarf",
        "label":"连打围巾",
        "effectAdd":"每次升级，偶数等级普通攻击的速度+0.6%，奇数等级攻击+0.8",
        "effectDescrption":"普通攻击命中时，会在3秒内产生隐藏的叠加效果，此效果在失效前每次普通攻击都可以叠加效果并刷新持续时间，最多可以叠加3次。叠加到3次后，自身的普通攻击的速度在5秒内提高15%/20%/25%。（等待时间：10秒）",
        "descripton":"进行3次普通攻击后，自身的普通攻击的速度在短时间内提高15%/20%/25%。",
        "sort":"攻击"
    },
    {
        "name":"CureCrown",
        "label":"治愈之冠",
        "effectAdd":"每次升级，偶数等级攻击+1.2，奇数等级体力+8",
        "effectDescrption":"攻击类的普通攻击造成伤害时，会回复相当于其伤害量7%/10%/13%的体力。普通攻击对护盾效果造成伤害时不会回复体力。",
        "descripton":"攻击类的普通攻击造成伤害时，会回复相当于其伤害量7%/10%/13%的体力。",
        "sort":"攻击"
    },
    {
        "name":"CurseBangle",
        "label":"咒术手镯",
        "effectAdd":"每次升级，攻击+0.8",
        "effectDescrption":"对对方宝可梦造成攻击类的伤害时，会在1.5秒内减弱对方宝可梦的体力回复效果20%/25%/30%。攻击类的普通攻击对对方宝可梦造成伤害时，减弱体力回复效果的时间会延长到3秒。",
        "descripton":"对对方宝可梦造成攻击类的伤害时，会在短时间内减弱对方宝可梦的体力回复效果20%/25%/30%。攻击类的普通攻击对对方宝可梦造成伤害时，会延长减弱体力回复效果的时间。",
        "sort":"攻击"
    },
    {
        "name":"CurseIncense",
        "label":"咒术熏香",
        "effectAdd":"每次升级，特攻+1.3",
        "effectDescrption":"对对方宝可梦造成特攻类的伤害时，会在1.5秒内减弱对方宝可梦的体力回复效果20%/25%/30%。特攻类的普通攻击对对方宝可梦造成伤害时，减弱体力回复效果的时间会延长到3秒。",
        "descripton":"对对方宝可梦造成特攻类的伤害时，会在短时间内减弱对方宝可梦的体力回复效果20%/25%/30%。特攻类的普通攻击对对方宝可梦造成伤害时，会延长减弱体力回复效果的时间。",
        "sort":"攻击"
    },
    {
        "name":"EnergyAmplifier",
        "label":"能量增幅器",
        "effectAdd":"每次升级，偶数等级等待时间-0.3%，奇数等级集结招式计量槽的增加速度+0.4%",
        "effectDescrption":"使用集结招式后，在4秒内自身造成的伤害增加7%/14%/21%。（等待时间：15秒）",
        "descripton":"使用集结招式后，短时间内自身造成的伤害增加7%/14%/21%。",
        "sort":"攻击"
    },
    {
        "name":"BuddyBarrier",
        "label":"救援屏障",
        "effectAdd":"每次升级，体力+15",
        "effectDescrption":"使用集结招式后，在5秒内为自身以及周围体力最低的友方宝可梦提供各自15%/20%/25%最大体力的护盾。护盾生效期间不会其他友方宝可梦的救援屏障触发而被替换，但是会重置护盾的持续时间。（等待时间：30秒）",
        "descripton":"使用集结招式后，为自身以及周围体力最低的友方宝可梦提供各自15%/20%/25%最大体力的护盾。",
        "sort":"其他"
    },
    {
        "name":"ScoreShield",
        "label":"得分护具",
        "effectAdd":"每次升级，体力+15",
        "effectDescrption":"正在进行得分时，获得相当于 (5%/7.5%/10%最大体力 + 30 × (自身等级-1) +30) 的护盾。获得护盾期间，得分不会被打断。此护盾会早于其他护盾效果被消耗。（等待时间：20秒）",
        "descripton":"正在进行得分时，获得相当于自身5%/7.5%/10%最大体力的护盾。自身的等级越高，护盾的效果越强。获得护盾期间，得分不会被打断。",
        "sort":"得分"
    },
    {
        "name":"AeosCookie",
        "label":"亿奥斯饼干",
        "effectAdd":"每次升级，体力+8",
        "effectDescrption":"使每次成功得分后，最大体力增加100/150/200。这个效果最多可叠加6次，不会因为被打倒重置。",
        "descripton":"每次成功得分后，最大体力增加100/150/200。",
        "sort":"得分"
    },
    {
        "name":"AttackWeight",
        "label":"猛攻哑铃",
        "effectAdd":"每次升级，攻击+0.6",
        "effectDescrption":"每次成功得分后，攻击提高6/9/12。这个效果最多可叠加6次，不会因为被打倒重置。",
        "descripton":"每次成功得分后，攻击提高6/9/12。",
        "sort":"得分"
    },
    {
        "name":"SpecialAttackSpecs",
        "label":"进击眼镜",
        "effectAdd":"每次升级，特攻+0.8",
        "effectDescrption":"每次成功得分后，特攻提高8/12/16。这个效果最多可叠加6次，不会因为被打倒重置。",
        "descripton":"每次成功得分后，特攻提高8/12/16。",
        "sort":"得分"
    },
    {
        "name":"ExpShare",
        "label":"学习装置",
        "effectAdd":"每次升级，偶数等级移动速度+10，奇数等级体力+16",
        "effectDescrption":"当自身的经验值为友方队伍内最低时，每秒获得3/4/5点经验值。当自身或周围的队友打倒野生宝可梦时，周围没有携带学习装置的队友能从中获得更多经验值。",
        "descripton":"当自身的经验值为友方队伍内最低时，每秒获得3/4/5点经验值。当队友打倒野生宝可梦时，该队友能额外获得少量经验值。",
        "sort":"其他"
    },
    {
        "name":"FloatStone",
        "label":"轻石",
        "effectAdd":"每次升级，偶数等级移动速度+10，奇数等级攻击+1.6",
        "effectDescrption":"脱离战斗期间，移动速度提高10%/15%/20%。（进入脱离战斗状态需要脱离战斗5秒以上）",
        "descripton":"脱离战斗期间，移动速度提高10%/15%/20%。",
        "sort":"其他"
    },
    {
        "name":"FocusBand",
        "label":"气势头带",
        "effectAdd":"每次升级，偶数等级特防+2，奇数等级防御+2",
        "effectDescrption":"体力低于25%时，在3秒内每秒回复已损失体力的6%/9%/12%。（等待时间：100/90/80秒）",
        "descripton":"体力较低时，在3秒内每秒回复已损失体力的6%/9%/12%。",
        "sort":"防御"
    },
    {
        "name":"Leftovers",
        "label":"吃剩的东西",
        "effectAdd":"每次升级，偶数等级回复体力+0.6，奇数等级体力+24",
        "effectDescrption":"脱离战斗期间，每秒回复2%/3%/4%最大体力。（进入脱离战斗状态需要脱离战斗5秒以上）",
        "descripton":"脱离战斗期间，每秒回复2%/3%/4%最大体力。",
        "sort":"防御"
    },
    {
        "name":"MuscleBand",
        "label":"力量头带",
        "effectAdd":"每次升级，偶数等级普通攻击的速度+0.5%，奇数等级攻击+1",
        "effectDescrption":"普通攻击命中时，增加相当于对方宝可梦当前体力1%/2%/3%的伤害。这个效果最多对对方队伍的宝可梦造成120/240/360伤害。每次触发效果时只会产生1次额外伤害，且只会有1只对方宝可梦受到此伤害。",
        "descripton":"普通攻击命中时，增加相当于对方宝可梦当前体力1%/2%/3%的伤害。",
        "sort":"攻击"
    },
    {
        "name":"RazorClaw",
        "label":"锐利之爪",
        "effectAdd":"会心一击率+0.5%，每次升级，偶数等级会心一击率+0.1%，奇数等级攻击+1",
        "effectDescrption":"使用招式后，下一次普通攻击会追加一次 (10/15/20 + 40%/45%/50%攻击) 的伤害。让近距离类别的宝可梦携带时，该次普通攻击命中对方宝可梦后，还会在1秒内降低其30%的移动速度。（等待时间：1.5秒）",
        "descripton":"使用招式后，下一次普通攻击会追加一次10/15/20以上的伤害，且攻击越高追加的伤害越高。让近距离类别的宝可梦携带时，该次普通攻击命中对方宝可梦后，还会在短时间内降低其移动速度。",
        "sort":"攻击"
    },
    {
        "name":"RescueHood",
        "label":"援助头巾",
        "effectAdd":"每次升级，偶数等级特防+2，奇数等级防御+2",
        "effectDescrption":"赋予自身以外的友方宝可梦回复或护盾效果时，回复效果提高5%/7.5%/10%，护盾效果提高5%/7.5%/10%。",
        "descripton":"赋予自身以外的友方宝可梦回复或护盾效果时，回复效果提高5%/7.5%/10%，护盾效果提高5%/7.5%/10%。",
        "sort":"其他"
    },
    {
        "name":"RockyHelmet",
        "label":"凸凸头盔",
        "effectAdd":"每次升级，偶数等级防御+3.4，奇数等级体力+18",
        "effectDescrption":"单次攻击受到高于10%最大体力的伤害时，对周围的对方宝可梦造成3%/4%/5%最大体力的伤害。（等待时间：2秒）",
        "descripton":"受到一定伤害时，对周围的对方宝可梦造成3%/4%/5%最大体力的伤害。",
        "sort":"防御"
    },
    {
        "name":"RustedSword",
        "label":"腐朽的剑",
        "effectAdd":"无",
        "effectDescrption":"据说在很久很久以前，英雄就是拿着这把剑驱走了灾厄。而现在，剑早已变得锈迹斑斑。此持有物必须且只能由苍响携带。",
        "descripton":"据说在很久很久以前，英雄就是拿着这把剑驱走了灾厄。而现在，剑早已变得锈迹斑斑。",
        "sort":"攻击"
    },
    {
        "name":"ScopeLens",
        "label":"焦点镜",
        "effectAdd":"每次升级，偶数等级会心一击增伤+0.8%，奇数等级会心一击率+0.4%",
        "effectDescrption":"用普通攻击打出会心一击时会造成 (45%/60%75%攻击) 的额外伤害。（等待时间：1秒）",
        "descripton":"用普通攻击打出会心一击时会增加伤害。攻击越高，增加的伤害越多。",
        "sort":"攻击"
    },
    {
        "name":"ShellBell",
        "label":"贝壳之铃",
        "effectAdd":"每次升级，偶数等级等待时间-0.3%，奇数等级特攻+1.6",
        "effectDescrption":"招式命中时回复自身 (50/65/80 + 40%/50%/60%特攻) 的体力。（等待时间：10秒）",
        "descripton":"招式命中时回复自身50/65/80以上的体力。特攻越高回复的体力越多。",
        "sort":"攻击"
    },
    {
        "name":"SlickSpoon",
        "label":"穿透汤匙",
        "effectAdd":"每次升级，偶数等级特攻+2，奇数等级体力+14",
        "effectDescrption":"特攻类的攻击造成的伤害，不受对方宝可梦的9%/13%/17%特防影响。",
        "descripton":"特攻类的攻击造成的伤害，不受对方宝可梦的9%/13%/17%特防影响。",
        "sort":"攻击"
    },
    {
        "name":"WeaknessPolicy",
        "label":"弱点保险",
        "effectAdd":"体力+60，每次升级，偶数等级攻击+1，奇数等级体力+10",
        "effectDescrption":"受到伤害后，在3秒内自身的攻击提高2%/2.5%/3%。此效果失效前每次受到伤害都可以叠加提高的攻击并刷新持续时间，最多可以叠加4次。",
        "descripton":"受到伤害后，短时间内自身的攻击提高2%/2.5%/3%以上。受到伤害的次数越多，攻击提高的幅度越大。",
        "sort":"防御"
    },
    {
        "name":"WiseGlasses",
        "label":"博识眼镜",
        "effectAdd":"特攻+9，每次升级，特攻+1",
        "effectAdd":"特攻提高3%/5%/7%。",
        "descripton":"特攻提高3%/5%/7%。",
        "sort":"攻击"
    },
    {
        "name":"ChargingCharm",
        "label":"充能坠饰",
        "effectAdd":"每次升级，移动速度+4，奇数等级攻击+1",
        "effectDescrption":"通过移动（每移动1个单位距离充能+1）和普通攻击（普通攻击每造成1次伤害充能+9）储蓄能量，能量储蓄到100时为全满。若在能量变为全满时对对方宝可梦造成伤害，会消耗全部充能并对1只对方宝可梦造成 (20/30/40 + 50%/60%/70%攻击) 的追加伤害。",
        "descripton":"通过移动和普通攻击储蓄能量。\n若在能量变为全满时对对方宝可梦造成伤害，则会造成追加伤害。",
        "sort":"攻击"
    },
    {
        "name":"ResonantGuard",
        "label":"共鸣护具",
        "effectAdd":"每次升级，体力+15，回复体力+0.6",
        "effectDescrption":"对对方宝可梦造成伤害时，会在3秒内为自身和周围体力最低的友方宝可梦提供 (60/80/100 + 4%/5%/6%自身最大体力) 的护盾效果。每次发动这个效果时，需要10秒的间隔时间。",
        "descripton":"对对方宝可梦造成伤害时，会赋予自身和周围的友方宝可梦护盾效果。\n每次发动这个效果时，需要一定的间隔时间。",
        "sort":"其他"
    },
]

// 持有物类型
prop.heldItemSort = [
    {
        "label":"攻击",
        "value":"攻击",
        "sort":"攻击"
    },
    {
        "label":"防御",
        "value":"防御",
        "sort":"防御"
    },
    {
        "label":"得分",
        "value":"得分",
        "sort":"防御"
    },
    {
        "label":"其他",
        "value":"其他",
        "sort":"防御"
    }
]
export default prop


// WEBPACK FOOTER //
// ./src/utils/prop.js